import { BaseFetch } from "../main-model"
export default class AcaCenBasicModel extends BaseFetch {
  getAcaCenBasicBy = (data) =>
    this.authFetch({
      url: "aca-cen-basic/getAcaCenBasicBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getAcaCenBasicById = (data) =>
    this.authFetch({
      url: "aca-cen-basic/getAcaCenBasicById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAcaCenBasicById = (data) =>
    this.authFetch({
      url: "aca-cen-basic/updateAcaCenBasicById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAcaCenBasic = (data) =>
    this.authFetch({
      url: "aca-cen-basic/insertAcaCenBasic",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAcaCenBasicById = (data) =>
    this.authFetch({
      url: "aca-cen-basic/deleteAcaCenBasicById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
